module.exports = __webpack_public_path__ + "static/media/12.70273abf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/12.jpg
// module id = 80
// module chunks = 0